import { useEffect } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { useFreestyleTools } from 'src/services';

import { LocalStore, useLocalActions } from '../store';

const useLocalState = createStateSelectorHook(LocalStore, ['freestyleToolContent']);

/**
 * When we initiate generation panel state from the latest generation results
 * and latest result was generated from "freestyle tool", this happens:
 *   1) "instructions" content gets be read from the result
 *   2) we will get "tool id" from result, but store it in "preload id" field
 * (see `LocalStore.initFreestyleToolFromGenerationResult` for implementation)
 *
 * This hook will load correct and full freestyle tool data if "preload id" was set.
 * If requested tool exists (was not deleted) then by calling `initFreestyleToolData`
 * we will rewrite current "freestyle" content of generation panel with actual data of tool entity.
 * Temporary "preload id" will be cleared by this call as well.
 */
export const usePreloadUsedFreestyleTool = () => {
  const { freestyleToolContent } = useLocalState();
  const preloadId = freestyleToolContent?.preloadId;
  const freestyleTools = useFreestyleTools();

  const localActions = useLocalActions();

  useEffect(() => {
    if (!preloadId) {
      return;
    }

    const freestyleTool = freestyleTools.find((tool) => tool.id === preloadId);
    if (freestyleTool) {
      localActions.initFreestyleToolData(freestyleTool);
    }
  }, [preloadId, freestyleTools, localActions]);
};
